<div class="dashboard">
  <h2 class="page-title">Overview</h2>
  <p class="page-subtitle">Platform summary and key insights</p>

  <div class="row g-3 mb-3">
    @for (kpi of kpis; track kpi.label) {
      <div class="col-6 col-lg-3">
        <app-kpi-card
          [icon]="kpi.icon"
          [iconBg]="kpi.iconBg"
          [iconColor]="kpi.iconColor"
          [label]="kpi.label"
          [value]="kpi.value"
          [change]="kpi.change"
        />
      </div>
    }
  </div>

  <div class="row g-3 mb-3 chart-row">
    <div class="col-lg-4">
      <div class="panel">
        <h3 class="panel-title">Most Used Tenants</h3>
        <table class="table table-borderless mb-2">
          <thead>
            <tr class="text-muted small">
              <th class="fw-normal">Tenant</th>
              <th class="fw-normal text-end">Active Users</th>
            </tr>
          </thead>
          <tbody>
            @for (t of mostUsedTenants; track t.name) {
              <tr>
                <td><i class="bi bi-building text-primary me-2"></i>{{ t.name }}</td>
                <td class="text-end">{{ t.users }}</td>
              </tr>
            }
          </tbody>
        </table>
        <a href="javascript:void(0)" class="panel-link mt-auto">View all tenants →</a>
      </div>
    </div>

    <div class="col-lg-4">
      <div class="panel">
        <h3 class="panel-title">Tenant Activity (This Month)</h3>
        <div class="activity-body">
          <div #activityChart class="donut-chart"></div>
          <div class="ms-3">
            <div class="legend-item"><span class="dot" style="background:#2563eb"></span>Active <strong>7 (58%)</strong></div>
            <div class="legend-item"><span class="dot" style="background:#93c5fd"></span>Inactive <strong>3 (25%)</strong></div>
            <div class="legend-item"><span class="dot" style="background:#dbeafe"></span>New <strong>2 (17%)</strong></div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-4">
      <div class="panel">
        <h3 class="panel-title">Service Usage (This Month)</h3>
        <div #usageChart class="usage-chart"></div>
        <a href="javascript:void(0)" class="panel-link">View all services →</a>
      </div>
    </div>
  </div>

  <div class="row g-3">
    <div class="col-lg-8">
      <div class="panel">
        <h3 class="panel-title">Recent Activity</h3>
        <table class="table table-borderless">
          <thead>
            <tr class="text-muted small">
              <th class="fw-normal">Activity</th>
              <th class="fw-normal">Tenant</th>
              <th class="fw-normal">User</th>
              <th class="fw-normal">Time</th>
            </tr>
          </thead>
          <tbody>
            @for (a of recentActivity; track a.activity + a.time) {
              <tr>
                <td>{{ a.activity }}</td>
                <td>{{ a.tenant }}</td>
                <td>{{ a.user }}</td>
                <td>{{ a.time }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>

    <div class="col-lg-4">
      <div class="panel">
        <h3 class="panel-title">Quick Actions</h3>
        <div class="quick-actions-body">
          @for (qa of quickActions; track qa.title) {
            <div class="quick-action" (click)="qa.route && router.navigate([qa.route])">
              <i [class]="qa.icon"></i>
              <div>
                <div class="qa-title">{{ qa.title }}</div>
                <div class="qa-subtitle">{{ qa.subtitle }}</div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
